// extracted by mini-css-extract-plugin
export default {"button":"AddIncomeButton_button__nxSnj","featuredIcon":"AddIncomeButton_featuredIcon__AJXuA"};